import request from '@/helpers/request'

export default {
  async index(date) {
    return await request.get('zoom_log_all', date)
  },
  async getTime(date) {
    return await request.get('melon_log/' + date)
  },
  async add(data) {
    return await request.post('melon_log', data)
  }
}
